import { ExclamationCircleIcon, TrashIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import { useDeleteKeywordGroup } from "../../api/BlueprintsApi";
import Button, {
  ButtonColorTypes,
  ButtonTypes,
} from "../../shared-components/Button";
import ErrorMessageContainer from "../../shared-components/ErrorMessageContainer";
import { Modal } from "../../shared-components/Modal";

type Props = {
  keywordUUID: string;
  onRemove: (keywordUUID: string) => void;
};

const KeywordRemove = ({ keywordUUID, onRemove }: Props) => {
  const [showModal, setShowModal] = useState(false);
  const {
    isLoading: isDeleteKeywordGLoading,
    mutate: deleteKeywordG,
    error: errorDeleteKeywordG,
    isSuccess: isSucessDelete,
  } = useDeleteKeywordGroup();

  useEffect(() => {
    if (isSucessDelete) {
      handleClose();
      onRemove(keywordUUID);
    }
  }, [keywordUUID, isSucessDelete, onRemove]);

  function handleClose() {
    setShowModal(false);
  }

  function handleRemove() {
    deleteKeywordG(keywordUUID);
  }

  return (
    <div>
      <TrashIcon
        className="w-4 cursor-pointer"
        onClick={() => {
          setShowModal(true);
        }}
      />
      <Modal open={showModal} onClose={handleClose} width={"w-104 p-3"}>
        <div>
          <div className="flex gap-4 mb-4">
            <div className="flex justify-center w-9 h-9 rounded-full bg-red-100">
              <ExclamationCircleIcon className="w-6 text-red-500" />
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-bold mb-2">
                Remove Keyword Group?
              </span>
              <span className="text-sm text-gray-400">
                Removing keyword group will detach it from it's behavior kit.
              </span>
            </div>
          </div>
          {errorDeleteKeywordG && (
            <ErrorMessageContainer message="Couldn't delete blueprint" />
          )}
          <div className="flex gap-4 justify-end">
            <Button
              text={"Cancel"}
              colorType={ButtonColorTypes.cancel}
              onClick={handleClose}
            />
            <Button
              type={
                isDeleteKeywordGLoading
                  ? ButtonTypes.saving
                  : ButtonTypes.default
              }
              text="Ok"
              colorType={ButtonColorTypes.secondary}
              onClick={handleRemove}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default KeywordRemove;
